function abortSignalAny(signals) {
    const ac = new AbortController();
    const handler = (event) => {
        signals.forEach(s => s.removeEventListener('abort', handler));
        ac.abort(event.target.reason);
    };
    signals.forEach(s => {
        if (ac.signal.aborted) {
            return;
        }
        if (s.aborted) {
            ac.abort(s.reason);
            return;
        }
        s.addEventListener('abort', handler);
    });
    return ac.signal;
}

export { abortSignalAny };
//# sourceMappingURL=abort.js.map
